import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getBarcodeItems as getBarcodeItemsAction,
  resetBarcodeItems,
  resetBarcodeItemsActions,
  setBarcodeItemsFilters,
  validateBarcodeItem,
} from 'store/barcode-items/actions';
import {
  getBarcodeItems as getBarcodeItemsSelector,
  getBarcodeItemsLoadingState as getBarcodeItemsLoadingStateSelector,
  getBarcodeItemsFilters as getBarcodeItemsFiltersSelector,
  getQueryArray, getIsBarcodeItemValid, getBarcodeItemValidationState, getIsBarcodeItemDuplicates,
} from 'store/barcode-items/selectors';

import Catalogue from './catalogue';
import { FILTER_KEYS } from '../../../../store/barcode-items/fixtures';
import DuplicateItemsModal from '../duplicates-confirm';

const {
  CATEGORIES,
  MANUFACTURERS,
} = FILTER_KEYS;

const PickBarcodeItemsFromCatalogue = ({ onSubmit, onClose, ...props }) => {
  const dispatch = useDispatch();
  const [barcodeItem, setBarcodeItem] = useState(null);
  const [isConfirmOpened, setConfirmOpened] = useState(false);
  const data = useSelector(getBarcodeItemsSelector);
  const filters = useSelector(getBarcodeItemsFiltersSelector);
  const isValid = useSelector(getIsBarcodeItemValid);
  const isValidating = useSelector(getBarcodeItemValidationState);
  const loading = useSelector(getBarcodeItemsLoadingStateSelector);
  const duplicates = useSelector(getIsBarcodeItemDuplicates);
  const query = useSelector(getQueryArray);

  const handleReset = () => {
    dispatch(resetBarcodeItems());
    dispatch(resetBarcodeItemsActions());
    dispatch(getBarcodeItemsAction());
  };

  const handleLoadMore = () => {
    dispatch(getBarcodeItemsAction());
  };

  // const handleChange = (selectedData) => {
  //   if (!barcodeItem || selectedData.id !== barcodeItem.id) {
  //     setBarcodeItem(selectedData);
  //   } else {
  //     setBarcodeItem(null);
  //   }
  // };

  const handleFilterChange = (values) => {
    dispatch(setBarcodeItemsFilters(values));
    dispatch(getBarcodeItemsAction());
  };

  const handleQueryParamDelete = ({ type, value }) => {
    const { [type]: updatedField, ...restFilters } = filters;

    handleFilterChange({
      ...restFilters,
      ...([CATEGORIES, MANUFACTURERS].includes(type) ? { [type]: updatedField.filter((itemId) => itemId !== value) } : {}),
      ...(type === FILTER_KEYS.QUERY ? { [type]: null } : {}),
    });
  };

  const handleSubmitValidation = (selectedData) => {
    setBarcodeItem(selectedData);

    const value = selectedData?.barcode;

    if(typeof value === 'string' && value.length) {
      dispatch(validateBarcodeItem({ barcode: value.trim() }));
    } else {
      // https://github.com/mickinuk/ColorMyLifeReact/issues/92
      // some barcode catalogue items do not have 'ean'/'upc' fields
      // so that check for duplicates is skipped
      onSubmit(selectedData);
    }
  };

  useEffect(() => {
    if(props.isOpened) {
      // handleFilterChange({
      //   ...filters,
      //   [FILTER_KEYS.SORT_DIRECTION]: 'barcodeDescription',
      // });
      // dispatch(getBarcodeItemsAction());
    } else {
      // dispatch(resetBarcodeItems());
      // dispatch(resetBarcodeItemsActions());
    }
  }, [props.isOpened]);

  useEffect(() => {
    if(!isValidating && barcodeItem) {
      if(!isValid) {
        setConfirmOpened(true);
        // setBarcodeFilters(JSON.parse(JSON.stringify(filters)));
      } else {
        onSubmit(barcodeItem);
      }
    }
  }, [isValidating]);

  if(props.isOpened && isConfirmOpened) {
    return (
      <DuplicateItemsModal
        text="Item(s) with the same barcode are already in your catalogue:"
        title="Duplicate found"
        data={duplicates}
        submitText="Create new item anyway"
        cancelText="Cancel"
        isOpened
        onClose={() => {
          setConfirmOpened(false);
          dispatch(resetBarcodeItemsActions());
        }}
        onSubmit={() => {
          onSubmit(barcodeItem);
          setConfirmOpened(false);
          dispatch(resetBarcodeItemsActions());
        }}
        overlayClassName="Overlay"
      />
    );
  }

  return (
    <Catalogue
      {...props}
      isSubmitOnPickEnabled
      selectedId={barcodeItem?.id}
      data={data}
      isLoading={loading}
      hasMore={filters[FILTER_KEYS.HAS_MORE]}
      onLoadMore={handleLoadMore}
      onReset={handleReset}
      onFilterChange={handleFilterChange}
      onQueryParamDelete={handleQueryParamDelete}
      filters={filters}
      query={query}
      onChange={handleSubmitValidation}
      onClose={onClose}
      // onSubmit={handleSubmitValidation}
      cancelActionAvailable={false}
      noContentMessage="There are no items to display"
    />
  );
};

export default PickBarcodeItemsFromCatalogue;
